import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

// To Do: use baseURL and remove full url from query
export const siteopsApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSiteOps: builder.query({
            query: () => `${getBaseURL()}/siteops`,
        }),
    }),
});

export const { useGetSiteOpsQuery } = siteopsApiSlice;
